
import BetModel from "slotworks/model/bets/bet-model";
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import Contract from "slotworks/utils/contracts/contract";

export function LoadSpinCommand(): Contract<void> {
    const payload = new SpinRequestPayload();
    payload.creditPerLine = BetModel.getCreditPerLine();
    payload.creditSize = BetModel.getCreditSize();

    return CommsManager.request(payload);
}
